// Browser Web Notifications Helper
export const requestNotificationPermission = async () => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return false;
    }
    if (Notification.permission === 'granted') {
        return true;
    }
    if (Notification.permission !== 'denied') {
        const permission = await Notification.requestPermission();
        return permission === 'granted';
    }
    return false;
};

export const sendBrowserNotification = (title, options = {}) => {
    if (typeof window === 'undefined' || !('Notification' in window)) {
        return;
    }
    if (Notification.permission === 'granted') {
        // Only trigger notification if document is hidden or inactive
        if (document.hidden) {
            try {
                new Notification(title, {
                    icon: '/favicon.ico',
                    badge: '/favicon.ico',
                    ...options,
                });
            } catch (e) {
                console.warn('Browser notification error:', e);
            }
        }
    }
};
